import React from "react";
import Work from "../Components/Work";
import { personalDetails, workDetails, eduDetails } from "../Details";

function About() {
  return (
    <main className="container mx-auto max-width pt-10 pb-20">
      <section className="flex flex-col justify-center">
        <h1 className="text-2xl text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          About Me
        </h1>
        <p className="text-content py-8 lg:max-w-3xl text-justify">{personalDetails.about}</p>
      </section>
      <section className="flex flex-col justify-center">
        <h1 className="text-2xl text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          Work Experience
        </h1>
        {React.Children.toArray(
          workDetails.map(({ Position, Company, Location, Type, Duration, techStack }) => (
            <Work
              position={Position}
              company={Company === "UniqueStrands LLC" ? <a href="https://www.uniquestrandsllc.com/" target="_blank" rel="noopener noreferrer">UniqueStrands LLC</a> : Company}
              location={Location}
              type={Type}
              duration={Duration}
              techStack={<b>Tech Stack: {techStack}</b>}
            />
          ))
        )}
      </section>
      <section className="flex flex-col justify-center">
        <h1 className="text-2xl pt-10 text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          Education
        </h1>
        {React.Children.toArray(
          eduDetails.map(({ Position, Company, Location, Duration, techStack }) => (
            <Work
              position={Position}
              company={Company}
              location={Location}
              duration={Duration}
              techStack={<b>{techStack}</b>}
            />
          ))
        )}
      </section>
    </main>
  );
}

export default About;
